const closeMenu = () => {
  const navbar = document.querySelector(".header nav");
  navbar?.classList.remove("open");
  document.body.classList.remove("stop-scrolling");
};

export const handleMobileMenu = () => {
  const navbar = document.querySelector(".header nav");
  if (!navbar?.classList.contains("open")) {
    navbar?.classList.add("open");
    document.body.classList.add("stop-scrolling");
  } else {
    closeMenu();
  }
  const links = document.querySelectorAll(".links a");
  links.forEach((link) => link.addEventListener("click", () => closeMenu()));
};
